export default "__VITE_ASSET__DgnCthlL__"